'use strict';

var formatter = angular.module('gymsystem.formatter', []);

formatter.factory('currency', [function () {
    var currency = {};
    var current;

    var currencies = {
        'SEK': { suffix: ' kr' },
        'USD': { prefix: '$' }
    };

    currency.set = function(c) {
        current = currencies[c];
    };

    currency.format = function(x) {
        return (current.prefix ? current.prefix : '') + x + (current.suffix ? current.suffix : '');
    };

    current = currencies.SEK;

    return currency;
}]);

formatter.factory('formatter', ['$filter', 'currency', 'genders', function ($filter, currency, genders) {
    var formatter = {};

    var escapeHtml = function(text) {
        if (text == null) return '';
        return String(text)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#039;');
    };

    var addThousandDelimiter = function(nStr, delimiter) {
        if (delimiter == undefined) {
            delimiter = ' ';
        }
        nStr += '';
        var x = nStr.split('.');
        var x1 = x[0];
        var x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + delimiter + '$2');
        }
        return x1 + x2;
    };

    var toFixedAndTrimmed = function(x) {
        if (x == undefined || x == null) {
            return "";
        }

        if (!angular.isString(x)) {
            x = String(x);
        }
        x = x.replace(',', '.');
        x = String(Number(x).toFixed(2));
        var parts = x.split('.');
        if (parts.length == 2) {
            x = parts[0];
            var ds = Number('0.' + parts[1]).toFixed(2).substring(2);
            var d = Number(ds);
            if (d) {
                x += ',' + ds;
            }
        }

        return x;
    };

    formatter.formatters = {
        price: function(x) {
            if (x == undefined || x == null) {
                return "";
            }

            if (!angular.isString(x)) {
                x = String(x);
            }
            x = x.replace(',', '.');
            x = String(Number(x).toFixed(2));

            var parts = x.split('.');
            var decimals = null;
            if (parts.length == 2) {
                var ds = Number('0.' + parts[1]).toFixed(2).substring(2);
                var d = Number(ds);
                if (d) {
                    decimals = ds;
                }
            }

            x = addThousandDelimiter(parts[0]) + (decimals ? ',' + decimals : '');
            return currency.format(x);
        },
        commaToDot: function(x) {
            if (x) {
                if (!angular.isString(x)) {
                    x = String(x);
                }
                x = x.replace(',', '.');
            }
            return x;
        },
        date: function(x) {
            if(x == null) {return '';}
            if(typeof(x) === 'string' && x.length === 10) {return x;}
            if(x && x.yyyymmdd) {return x.yyyymmdd();}
            return '' + x;
        },
        datetime: function(x) {
            if(x == null) {return '';}
            if(x && x.dateTime) {return x.dateTime();}
            return '' + x;
        },
        datetimeseconds: function(x) {
            if(x == null) {return '';}
            if(x && x.dateTime) {
                var s = String(x.getSeconds());
                return x.dateTime() + ':' + (s[1] ? s : '0'+s);
            }
            return '' + x;
        },
        datetimeshort: function(x) {
            if (!x) {
                return x;
            } else if (x.isMidnight()) {
                return x.yyyymmdd();
            } else {
                return x.dateTime();
            }
        },
        time: function(x) {
            return x && x.hhmm();
        },
        relativedate: function(x) {
            if (x) {
                var ft = x.daysFromToday();
                if (ft > 6 || ft < 0) {
                    return x.yyyymmdd();
                } else {
                    var res = [];
                    if (ft == 0) {
                        res = ['Today'];
                    } else if (ft == 1) {
                        res = ['Tomorrow', x.getWeekDayString()];
                    } else {
                        res = [x.getWeekDayString()];
                    }

                    return res.map($filter('translate')).join(' ');
                }
            }
        },
        relativedatetime: function(x) {
            if (x) {
                var ft = x.daysFromToday();
                if (ft > 6 || ft < 0) {
                    return formatter.formatters.datetimeshort(x);
                } else {
                    var res = [];
                    if (ft == 0) {
                        res = ['Today'];
                    } else if (ft == 1) {
                        res = ['Tomorrow', x.getWeekDayString()];
                    } else {
                        res = [x.getWeekDayString()];
                    }

                    var time = x.isMidnight() ? '' : ' ' + x.hhmm();
                    return res.map($filter('translate')).join(' ') + time;
                }
            }
        },
        relativetime: function(x) {
            if (x) {
                if (x.isFuture()) {
                    return x.yyyymmdd();
                }
                var now = new Date().getTime();
                var timeSince = (now - x.getTime());
                var minutes = Math.floor(timeSince / (1000 * 60));
                if (minutes < 60) {
                    return minutes + ' ' + $filter('translate')(minutes == 1 ? 'minute' : 'minutes') + ' ' + $filter('translate')('ago');
                }
                var hours = Math.floor(minutes / 60);
                if (hours < 24) {
                    return hours + ' ' + $filter('translate')(hours == 1 ? 'hour' : 'hours') + ' ' + $filter('translate')('ago');
                }
                return x.yyyymmdd();
            }
        },
        datemonthname: function(x) {
            if (x) {
                return $filter('translate')(x.getWeekDayString()) + " " + x.getDate() + " " + $filter('translate')(x.getMonthName());
            }
        },
        personalCodeNumber: function(x) {
            if (x) {
                if (x.length == 12) {
                    return x.substring(0,8) + "-" + x.substring(8, 12);
                } else if (x.length == 10) {
                    return x.substring(0,6) + "-" + x.substring(6, 10);
                }
            }

            return x;
        },
        corporateIdentity: function(x) {
            return formatter.formatters.personalCodeNumber(x);
        },
        gender: function(x) {
            var g = _.findWhere(genders.getList(), {id: x});
            if (g) {
                return $filter('translate')(g.name);
            }
        },
        percentage: function(x) {
            return toFixedAndTrimmed(x * 100) + ' %';
        },
        percent: function(x) {
            return toFixedAndTrimmed(x * 100) + ' %';
        },
        percentNoMult: function(x) {
            return toFixedAndTrimmed(x) + ' %';
        },
        float: function(x) {
            return toFixedAndTrimmed(x);
        },
        numberNice: function(x) {
            return addThousandDelimiter(toFixedAndTrimmed(x));
        },
        bool: function(x) {
            return $filter('translate')(x ? 'Yes' : 'No');
        },
        tristate: function(x) {
            if (x == false || x == true) {
                return $filter('translate')(x ? 'Yes' : 'No');
            }
        },
        translatedCommaList: function(x) {
            if (x) {
                var names = [];
                for (var i=0; i < x.length; ++i) {
                    names[i] = $filter('translate')(angular.isObject(x[i]) ? x[i].name : x[i]);
                }
                return names.join(", ");
            }
        },
        commaList: function(x) {
            if (x) {
                if (!_.isArray(x)) {
                    return x;
                }
                var names = [];
                for (var i=0; i < x.length; ++i) {
                    names[i] = angular.isObject(x[i]) ? x[i].name : x[i];
                }
                return names.join(", ");
            }
        },
        count: function(x) {
            if (x) {
                if (_.isArray(x)) {
                    return x.length;
                }
            }
            return 0;
        },
        translated: function(x) {
            return $filter('translate')(x);
        },
        json: function(x) {
            return $filter('json')(x);
        },
        number: function(x) {
            if (x == null) {
                return '';
            }
            return Number(x);
        },
        bankgiroNumber: function(x) {
            if (x) {
                x = String(x);
                if (x.length == 6) {
                    x = x.insertAt(3, '-');
                } else if (x.length >= 6) {
                    x = x.insertAt(x.length - 4, '-');
                }
            }

            return x;
        },
        exceldate: function(x) {
            if (x && !angular.isString(x)) {
                //x = new Date((x - (25567 + 1))*86400*1000).yyyymmdd();
                x = new Date((x - (25567 + 2))*86400*1000).yyyymmdd();
            }
            return x;
        },
        exceldatetime: function(x) {
            if (x && !angular.isString(x)) {
                //x = new Date((x - (25567 + 1))*86400*1000).dateTime();
                x = new Date((x - (25567 + 2))*86400*1000).dateTime();
            }
            return x;
        },
        discountedprice: (amount, discount) => {
            if (!Number(discount)) {
                return formatter.format('price', amount);
            } else {
                return '<span class="discount">' + formatter.format('price', Number(amount) + Number(discount)) + '</span>' + '&nbsp;<span>' + formatter.format('price', amount) + '</span>';
            }
        },
        discountedpriceleft: (amount, extra) => {
            let left = extra.left;
            let discount = extra.discount;
            if (left == amount) {
                return formatter.formatters.discountedprice(amount, discount);
            }

            let leftText = $filter('translate')('left').capitalize();
            if (!Number(discount)) {
                return formatter.format('price', amount) + ' (' + leftText + ': ' + formatter.format('price', left) + ')';
            } else {
                return '<span class="discount">' + formatter.format('price', Number(amount) + Number(discount)) + '</span>' + '&nbsp;<span>' + formatter.format('price', amount) + ' (' + leftText + ':' + formatter.format('price', left) + ')' + '</span>';
            }
        },
        keyvalue: value => {
            try {
                const data = typeof(value) == 'string' ? JSON.parse(value) : value;
                return Object.entries(data).map(([key, val]) => {
                    const escapedVal = Array.isArray(val) ? val.map(v => escapeHtml(v)).join(', ') : escapeHtml(val);
                    return `<strong>${escapeHtml(key)}</strong>: ${escapedVal}`;
                }).join('<br>');
            } catch (e) {
                return '';
            }
        },
        keyvalueLineSeparatedList: value => {
            try {
                const data = typeof(value) == 'string' ? JSON.parse(value) : value;
                return Object.entries(data).map(([key, val]) => {
                    const escapedVal = Array.isArray(val) ? val.map(v => escapeHtml(v)).join(', ') : escapeHtml(val);
                    return `${escapeHtml(key)}: ${escapedVal}`;
                }).join('\n');
            } catch (e) {
                return '';
            }
        },
        htmlList: value => {
            if (Array.isArray(value)) {
                return value.map(v => escapeHtml(v)).join('<br>');
            }
        },
        newLineList: value => {
            if (Array.isArray(value)) {
                return value.join('\n');
            }
        },
    };

    formatter.getFormatter = function(type) {
        return formatter.formatters[type];
    };

    formatter.format = function(type, value, extra) {
        var f = formatter.getFormatter(type);
        value = f ? f(value, extra) : value;
        return value;
    };

    formatter.requiresHtml = function(type) {
        return ['discountedprice', 'discountedpriceleft', 'keyvalue', 'htmlList'].includes(type);
    }

    return formatter;
}]);

formatter.filter('formatter', ['formatter', function(formatter) {
    return function(value, format) {
        return formatter.format(format, value);
    };
}]);

formatter.filter('joinlist', [function() {
    return function(value, prop) {
        if(!value || !value.length) {return '';}
        var result = [];
        value.forEach(function(item) {
            if(item[prop]) {
                result.push(item[prop]);
            }
        });
        return result.join(' ');
    };
}]);
